





















































































































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { ServiceProxy } from "@/service-proxies/app-v2/auth.service-proxies";
import { TenantExtendServiceProxy as TenantService } from "@/service-proxies/app-v2/system.service-proxies";
import { getLocalStorage, setLocalStorage } from "@/utils/storage";
import { getLang } from '../language'
import { queryRole } from "@/api/api";

const serviceProxy = new ServiceProxy();
const tenantService = new TenantService();

function hasErrors(fieldsError: any) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

export default Vue.extend({
  props: {
    type: {
      // 登录方式：{pwd: 账密登录，code：手机验证码登录}
      type: String,
      default: "pwd",
    },
  },
  data() {
    let msg = getLang('page_login_btnText1')
    return {
      getLang,
      hasErrors,
      form: this.$form.createForm(this),
      loading: false,
      redirect: undefined,
      otherQuery: {},
      sendingCode: false,
      btnText: msg,
      tenantId: "",
      flag: false,
      tenantCode: "",
    };
  },
  computed: {
    ...mapGetters(["userSettings"]),
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
    userSettings: {
      handler(val) {
        if (val && val.tenantId) {
          // 从个性化设置里带出来的租户id，此时不必再输入租户名称
          this.tenantId = val.tenantId;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 按钮置灰
      this.form.validateFields();
    });
  },
  created() {
    const href2 = window.location.host.split(".")[1];
    const domain = window.location.host.split(".")[0];
    // 排除localhost；二级域名存在；二级域名为masterlink时显示公司名称
    if (href2 && domain) {
      // 此判断下域名可能有效，下面需要进一步判断
      this.flag = domain !== "masterlink";
    }
  },
  methods: {
    ...mapActions("user", ["login"]),

    usernameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("username") && getFieldError("username");
    },
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    mobileError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("socialId") && getFieldError("socialId");
    },
    validateMobile(rule: any, value: string, callback: any) {
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if (value && !valid_rule.test(value)) {
        callback(this.getLang("page_login_socialId_err_tip"));
      } else {
        callback();
      }
    },
    codeError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("code") && getFieldError("code");
    },
    // 获取验证码
    getCode() {
      const form = this.form;
      const mobile = form.getFieldValue("socialId");
      const tanant = form.getFieldValue("tenant");
      if (!tanant) {
        this.$message.error(this.getLang("page_login_tenant_tip2"));
      }
      tenantService.getTenantIdByTenantCode(tanant).then((res: any) => {
        if (res) {
          // 发送验证码，入参：mobile，tenantId
          serviceProxy.smsValidateCodeUsingGET(mobile, res).then((res) => {
            this.$message.info(res.msg);
            // 60秒倒计时
            this.sendingCode = true;
            let msgTime = 60;
            const time = setInterval(() => {
              msgTime--;
              this.btnText = (this.getLang('page_login_btnText2')).replace('{0}', msgTime);
              // this.btnText = msgTime + this.getLang("page_login_btnText2");
              if (msgTime === 0) {
                msgTime = 60;
                this.sendingCode = false;
                this.btnText = this.getLang("page_login_btnText1");
                clearInterval(time);
              }
            }, 1000);
          });
        }
      });
    },
    handleSubmit(e: any) {
      this.loading = true;
      e.preventDefault();
      let values = this.form.getFieldsValue();
      this.tenantCode = values.tenant;
      if (this.flag && !this.tenantCode) { // 二级域名
        this.tenantCode = window.location.host.split('.')[0]
      }
      tenantService
        .getTenantIdByTenantCode(this.tenantCode)
        .then((res: any) => {
          if (res) {
            this.tenantId = res;
          }
          let params = {
            type: this.type,
            tenantId: this.tenantId,
            grantType: this.type === "code" ? "mobile" : "",
          };
          Object.assign(params, values);
          this.login(params)
            .then(() => {
              
              // 获取tenant详情
              queryRole(res).then(item => {
                const dataTenant = item.data.data
                setLocalStorage("TENANTNAME", dataTenant.tenantName)
              })
              
              setLocalStorage("TENANT", { tenantCode: this.tenantCode });
              setLocalStorage("PWD", values.password);
              this.$router.push({
                path: this.redirect || "/",
                query: this.otherQuery,
              });
              this.loading = false;
            })
            .catch(() => {
              // this.$message.error('登录失败，请稍后再试')
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getOtherQuery(query: any) {
      return Object.keys(query).reduce((acc: any, cur: any) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
  },
});
